import "./common/main-navigation"
import "./common/quantity-input"
import "./common/cart-summary"
import "./common/variant-selection"
import "./common/gallery"
import "./common/header-drawer"
import "./common/inline-search"
import "./common/cart-button"
import "./common/add-to-wishlist"
import "./common/add-to-cart"
import "./common/recommended-products"

// DYNAMIC REACT APP

const noop = () => {}

const loadWishlistReactApp = async () => {
    if (document.querySelector('#react-wishlist')) {
        return import('./wishlist')
    }
}
const loadPersonalizeProductReactApp = async () => {
    if (document.querySelector('#react-personalize-product')) {
        return import('./personalize-product')
    }
}

const loadToastMessagesReactApp = async () => {
    if (document.querySelector('#react-toast-messages')) {
        return import('./toast-messages')
    }
}

loadWishlistReactApp().then(noop)
loadPersonalizeProductReactApp().then(noop)
loadToastMessagesReactApp().then(noop)

// MISC
const mobileOnlyDetails = document.querySelectorAll('details[data-mobile-only]')

// mobile only details must open when the `md` breakpoint is reached
mobileOnlyDetails.forEach(details => {
    const mediaQuery = window.matchMedia('(min-width: 768px)')
    if (mediaQuery.matches) {
        details.open = true
    }

    window.addEventListener('resize', () => {
        if (mediaQuery.matches) {
            details.open = true
        }
    })
})